.link {
  align-items: center;
  background: transparent;
  border: 3px dashed var(--color-muted);
  border-radius: 10px;
  color: var(--color-text-muted);
  cursor: pointer;
  display: flex;
  font-family: var(--font-family-base);
  font-size: 1.25rem;
  gap: 0.5rem;
  justify-content: center;
  margin: 0 0 1rem;
  padding: 2rem;
  text-align: center;
  width: 100%;
}

@media (max-width: 640px) {
  .link {
    font-size: 1.5rem;
    padding: 1.5rem 1rem;
  }
}
